module.exports = __webpack_public_path__ + "static/media/image_certificate_m.98c51e54.png";